import { useRecoilState } from 'recoil';
import { useEffect } from 'react';

import useTeeshotApiRequest from './use-teeshotApiRequest';
import { commonState } from '../recoil/commonState';

export default function useCommonData() {
    const [initialCommonData, setCommonData] = useRecoilState(commonState);
    const { request } = useTeeshotApiRequest();

    // 최초 마운트에서 공통 데이터 1회 로드 (의존성 배열에 넣으면 재요청 루프 위험)
    useEffect(() => {
        (async () => {
            const data = await request({
                method: 'GET',
                url: `/common/groupBooking`,
            });
            setCommonData({ ...initialCommonData, ...data });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount 시 1회만
    }, []);
}
